// Angular Imports
import { NgModule } from '@angular/core';
// This Module's Components
import { SkipNavigationComponent } from './skip-navigation.component';

@NgModule({
  imports: [],
  declarations: [SkipNavigationComponent],
  exports: [SkipNavigationComponent]
})
export class NgcSkipNavigationModule {}
